import createIcon from '../../createIcon';

/**
 * @component @name CenterFocusWeak
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAxNUgzVjE5QzMgMjAuMSAzLjkgMjEgNSAyMUg5VjE5SDVWMTVaTTUgNUg5VjNINUMzLjkgMyAzIDMuOSAzIDVWOUg1VjVaTTE5IDNIMTVWNUgxOVY5SDIxVjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xOSAxOUgxNVYyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWMTVIMTlWMTlaTTEyIDhDOS43OSA4IDggOS43OSA4IDEyQzggMTQuMjEgOS43OSAxNiAxMiAxNkMxNC4yMSAxNiAxNiAxNC4yMSAxNiAxMkMxNiA5Ljc5IDE0LjIxIDggMTIgOFpNMTIgMTRDMTAuOSAxNCAxMCAxMy4xIDEwIDEyQzEwIDEwLjkgMTAuOSAxMCAxMiAxMEMxMy4xIDEwIDE0IDEwLjkgMTQgMTJDMTQgMTMuMSAxMy4xIDE0IDEyIDE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CenterFocusWeak = createIcon('CenterFocusWeak', [
  [
    'path',
    {
      d: 'M5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15ZM5 5H9V3H5C3.9 3 3 3.9 3 5V9H5V5ZM19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3ZM19 19H15V21H19C20.1 21 21 20.1 21 19V15H19V19ZM12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14Z',
      key: 'xbdm9f',
    },
  ],
]);

export default CenterFocusWeak;
